import React, { useImperativeHandle, forwardRef, useRef } from 'react';

import BlankFilling from './blankFilling';

const QuesCompWithInput = forwardRef((props, ref) => {
  const selectionRef = useRef(null);
  const inputRef = useRef(null);

  const { quesComp: SelectionComp } = props;

  useImperativeHandle(ref, () => ({
    getValues: () =>
      Object.assign(
        {},
        selectionRef.current.getValues(),
        inputRef.current.getValues(),
      ),
  }));
  return (
    <div>
      <div className="select-before-input">
        <SelectionComp {...props} ref={selectionRef} />
      </div>
      <BlankFilling {...props} ref={inputRef} />
    </div>
  );
});

const WithAdditionalInput = (qComp) =>
  forwardRef((props, ref) => (
    <QuesCompWithInput {...props} quesComp={qComp} ref={ref} />
  ));

export default WithAdditionalInput;
